// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceHeader_wrapper__z0g8F","title":"ServiceHeader_title__KJKcg","button_back":"ServiceHeader_button_back__iTZkV"};